export default __webpack_public_path__ + "static/media/480_business06-es-web.a50bfd87.png";